/*
 * @providesModule GameThemeBackground
 */

import SkillzImage from 'SkillzImage';
import SkillzStyle from 'SkillzStyle';
import AssetHelper from 'AssetHelper';
import {StyleSheet, View} from 'react-native';

export const GameThemeBackground = (): React.ReactElement => {
  const hasBackgroundImage = !!SkillzStyle.getOverriddenFallbackTheme()?.backgroundImage;
  const st = SkillzStyle.getOverriddenFallbackTheme();

  if (hasBackgroundImage) {
    return (
      <>
        <SkillzImage
          resizeMode='cover'
          style={styles.backgroundContainer}
          priority='high'
          source={{
            uri: AssetHelper.pathForAssetNamed(st.backgroundImage, false),
          }}
        />
      </>
    );
  } else {
    return <View />;
  }
};

const styles = StyleSheet.create({
  backgroundContainer: {
    ...StyleSheet.absoluteFillObject,
  },
  backgroundOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
  },
});
